import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { FormElementModel } from '@smarttask-common/src/lib/models/Form/Element/FormElementModel';

export enum FormElementActionTypes {
    ADD_FORM_ELEMENT = '[FormElement] Create FormElement',
    ADD_FORM_ELEMENTS = '[FormElement] Add FormElements',
    UPSERT_FORM_ELEMENT = '[FormElement] Upsert FormElement',
    UPSERT_FORM_ELEMENTS = '[FormElement] Upsert FormElements',
    UPDATE_FORM_ELEMENT = '[FormElement] Update FormElement',
    UPDATE_FORM_ELEMENTS = '[FormElement] Update FormElements',
    DELETE_FORM_ELEMENT = '[FormElement] Delete FormElement',
    DELETE_FORM_ELEMENTS = '[FormElement] Delete FormElements',
    DELETE_ALL_FORM_ELEMENTS = '[FormElement] Delete All FormElements',
    DELETE_ALL = '[FormElement] Delete All',

    UPDATE_SELECTED_ID = '[FormElement] Update SelectedId',
}

export class UpdateSelectedFormElementId implements Action {
    readonly type = FormElementActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_element_id: string) {}
}

export class AddOne implements Action {
    readonly type = FormElementActionTypes.ADD_FORM_ELEMENT;
    constructor(public element: FormElementModel) {}
}

export class AddMany implements Action {
    readonly type = FormElementActionTypes.ADD_FORM_ELEMENTS;
    constructor(public elements: Array<FormElementModel>) {}
}

export class UpsertOne implements Action {
    readonly type = FormElementActionTypes.UPSERT_FORM_ELEMENT;

    constructor(public element: FormElementModel) {}
}

export class UpsertMany implements Action {
    readonly type = FormElementActionTypes.UPSERT_FORM_ELEMENTS;
    constructor(public elements: Array<FormElementModel>) {}
}

export class UpdateOne implements Action {
    readonly type = FormElementActionTypes.UPDATE_FORM_ELEMENT;
    constructor(public element: Update<FormElementModel>) {}
}

export class UpdateMany implements Action {
    readonly type = FormElementActionTypes.UPDATE_FORM_ELEMENTS;
    constructor(public elements: Array<Update<FormElementModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = FormElementActionTypes.DELETE_FORM_ELEMENT;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = FormElementActionTypes.DELETE_FORM_ELEMENTS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = FormElementActionTypes.DELETE_ALL_FORM_ELEMENTS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = FormElementActionTypes.DELETE_ALL;
    constructor() {}
}

export type FormElementActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedFormElementId;
